export const ProcessEnvConfig = {
  haveShopMall: process.env.REACT_APP_HAVE_SHOP_MALL === 'true',
};
